import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ProductProvider } from "../context/ProductContext";
import { CartProvider } from "../context/CartContext";
import { AuthProvider } from "../context/AuthContext";
import { MyClientsProvider } from "../context/MyClientsContext";
import { MyAccountProvider } from "../context/MyAccountContext";
import { queryClient } from "../config/queryClient";

const ContextProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MyAccountProvider>
          <MyClientsProvider>
            <CartProvider>
              <ProductProvider>{children}</ProductProvider>
            </CartProvider>
          </MyClientsProvider>
        </MyAccountProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};
export default ContextProvider;
